import { notification } from 'antd';
import parseDate, { BENCHMARK_DATE_FORMAT } from '../../../../utils/parse-date';

export const FORM_NAME = 'manageCaseFileType';

export const NOTIFICATION_ERROR = 'error';
export const NOTIFICATION_SUCCESS = 'success';

export const MAXIMUM_DAYS_VALUE = 999999;
export const MINIMUM_DAYS_VALUE = 2;

export const CLOSED_STATUS = 'CLOSED';
export const OPEN_STATUS = 'OPEN';
export const PAUSED_STATUS = 'PAUSED';

export const DEFAULT_PAUSED_STATUS_LABEL = 'Paused';

export const CASE_FILE_START_DATE_ATTRIBUTE_NAME = 'startDate';

export const START_DATE_COMPLAINT_DATE = 'COMPLAINT';
export const START_DATE_INCIDENT_DATE = 'INCIDENT';
export const START_DATE_CREATION_DATE = 'CREATION';

export const START_DATE_TYPE_OPTIONS = [
  { label: 'Complaint Date', value: 'COMPLAINT' },
  { label: 'Incident Date', value: 'INCIDENT' },
  {
    label: 'Case File Creation Date (Default)',
    value: START_DATE_CREATION_DATE,
  },
];

export const MIN_PERIOD_DAYS_VALUE = 1;
export const MAX_PERIOD_DAYS_VALUE = 366;
export const TOLLING_REASON_MAX_LENGTH = 100;
export const TOLLING_CATEGORY_SUSPENSION = 'SUSPENSION';
export const TOLLING_CATEGORY_EXTENSION = 'EXTENSION';

// ERROR HANDLING
export function showError(err) {
  const message = err.message || 'API response is not ok';
  showNotification(NOTIFICATION_ERROR, 'Error', message);
}

export function showSuccess(message) {
  showNotification(NOTIFICATION_SUCCESS, 'Success', message);
}

export function showNotification(type, message, description) {
  return notification[type]({ message, description });
}

// TABLE CONFIGURATION
export function renderDate(data, timezone) {
  if (data) {
    const date = parseDate(data, timezone, BENCHMARK_DATE_FORMAT);
    return `${date}`;
  }
  return '';
}

export function sortAlphabetically(a, b, field) {
  if (a[field] < b[field]) {
    return -1;
  }
  if (a[field] > b[field]) {
    return 1;
  }
  return 0;
}

export function sortByCreationDate(a, b) {
  if (a.createdAt < b.createdAt) {
    return -1;
  }
  if (a.createdAt > b.createdAt) {
    return 1;
  }
  return 0;
}
